import PaginationButton from "./PaginationButton";
export default PaginationButton;
